import React, {useEffect, useState} from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import ProductService from "@/modules/front/services/ProductService";
import VariantSelector from "@/modules/front/VariantSelector";

export const AddToCartModal = ({
                                   recommendedProducts,
                                   dateFrom, dateTo,
                                   productId,
                                   ...props
                               }) => {

    const handleClose = () => {
        props.onHide();
    }

    const [loading, setLoading] = useState(true);
    const [recommendedItems, setRecommendedItems] = useState([]);
    const [selectedIds, setSelectedIds] = useState([]);
    const [submitting, setSubmitting] = useState(false);

    console.log(selectedIds);

    useEffect(() => {
        ProductService.getRecommendedItems(productId, dateFrom, dateTo).then((data) => {
                setRecommendedItems(Object.keys(data).map((key) => data[key]));
                setLoading(false);
                console.log(data);
            }
        );
    }, []);


    let items = recommendedItems.map((item, index) => {
        return recommendedItems[index];
    });

    console.log(items, '35');

    let itemsGrouped = [];
    for (let i = 0; i < items.length; i++) {
        if (items[i].product.subri_variant_of) {
            if (!itemsGrouped[items[i].product.subri_variant_of]) {
                itemsGrouped[items[i].product.subri_variant_of] = {
                    variants: [],
                    product: items[i].product,
                    image: items[i].image
                };
            }
            itemsGrouped[items[i].product.subri_variant_of].variants.push(items[i]);
        } else {
            itemsGrouped[items[i].product.id] = items[i];
        }
    }

    let itemsElements = [];
    for (let i = 0; i < itemsGrouped.length; i++) {
        itemsElements[i] =
            <RecommendationItem item={itemsGrouped[i]} index={i} onChange={(checked, productId, toUncheckIds) => {
                let ids = selectedIds;
                ids = ids.filter((id) => !toUncheckIds.includes(id));
                if (checked) {
                    ids.push(productId);

                }
                setSelectedIds(ids);
            }}/>
    }


    const handleSubmit = () => {
        if (submitting) {
            return;
        }
        setSubmitting(true);

        let ids = [productId, ...selectedIds];

        let productsIdsCsv = ids.join(',');

        let urlApi = new URL(window.links.reservation.addToCartJson);
        let item = recommendedItems[0];
        urlApi.searchParams.append('dateFrom', dateFrom);
        urlApi.searchParams.append('dateTo', dateTo);
        urlApi.searchParams.append('productId', productsIdsCsv);
        urlApi.searchParams.append('officeId', 1);

        const urlApiString = urlApi.toString();
        console.log(urlApiString);
        fetch(urlApiString, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    window.location.href = window.links.reservation.finish;
                } else {
                    alert(data.error);
                    setSubmitting(false);
                }
            });
    }

    return (
        <>
            <Modal
                show={props.show}
                size={'lg'}
                onHide={handleClose}
                centered={true}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Přidat do košíku</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loading ? 'Načítání...' : itemsElements}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Zavřít
                    </Button>

                    <Button variant="primary" disabled={submitting} onClick={handleSubmit}>Přidat do košíku {submitting ? <i className="fa fa-spinner fa-spin"></i> : ''}</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

const RecommendationItem = ({item, index, onChange}) => {
    if (!item) {
        return null;
    }

    const [checked, setChecked] = useState(false);
    const [productId, setProductId] = useState(item.product.id);
    const [didMount, setDidMount] = useState(false);

    useEffect(() => {
        setDidMount(true);

    }, []);

    useEffect(() => {
        let toUncheck = [productId];
        toUncheck.push(...item.variants.map((variant) => variant.product.id));

        onChange(checked, productId, toUncheck);

    }, [checked, productId]);

    useEffect(() => {
        if (didMount) {
            setChecked(true);
        }

    }, [productId]);


    let mainTitle = item.product.parentTitle ? item.product.parentTitle : item.product.title;

    return (
        <div key={index}
             className={'d-flex align-items-center border border-2 my-2 p-3 cursor-pointer' + (checked ? ' border-primary' : '')}>
            <div onClick={() => setChecked(!checked)}>
                <input type="checkbox" checked={checked} onChange={() => setChecked(!checked)}/>
            </div>
            <div className='me-3' onClick={() => setChecked(!checked)}>
                <img src={item.image} alt={mainTitle} width={50}/>
            </div>
            <div className={'d-flex align-items-center'}>
                <a className={'me-3 cursor-pointer text-black text-decoration-none'} onClick={() => setChecked(!checked)} style={{cursor: 'pointer'}}>
                    {mainTitle}
                </a>
                <VariantSelector variants={item.variants.map(
                    (variant) => {
                        return {
                            id: variant.product.id,
                            title: variant.product.title
                        }
                    }
                )} onVariantChange={(variant) => {
                    setProductId(variant);
                }}/>

            </div>
        </div>
    );
}